import cn from "classnames";
import { ReactNode } from "react";
import { useMediaQuery } from "../../ui-kit";
import { ChatHeader } from "../../../modules/chat/components/chat-header";
import styles from "./chat-with-header.module.scss";

type Props = {
  children: ReactNode;
};

export const ChatWithHeader = ({ children }: Props) => {
  const isMobile = useMediaQuery("mobile");

  const containerStyles = cn(styles["chat-container"], {
    [styles.mobile]: isMobile,
  });

  const chatStyles = cn(styles.chat, {
    [styles.desktop]: !isMobile,
  });

  return (
    <div className={containerStyles}>
      <section className={chatStyles}>
        <ChatHeader />
        {children}
      </section>
    </div>
  );
};
